// 9fbef606107a605d69c0edbcd8029e5d
import React from 'react';
import PropTypes from 'prop-types';
import { Field, FormSection } from 'redux-form';
import {
  getLabelFromCopyOrFromTranslation,
  renderLabel,
} from '@tcp/core/src/utils/labels/labelUtilty';
import {
  GLOBAL_GENERIC_LABELS,
  GlobalGenericLabels,
  lblPhoneNumber,
} from '@tcp/core/src/utils/labels/globalGeneric.labels';
import GlobalAddEditAddressLabels, {
  GLOBAL_ADD_EDIT_ADDRESS_LABELS,
} from '@tcp/core/src/utils/labels/globalAddEditAddress.labels';
import checkoutLabels from '@tcp/core/src/utils/labels/cnc/checkout.labels';
import BodyCopy from '@tcp/core/src/components/common/atoms/BodyCopy';
import TextBox from '@tcp/core/src/components/common/atoms/TextBox';
import Col from '@tcp/core/src/components/common/atoms/Col';
import Row from '@tcp/core/src/components/common/atoms/Row';
import { getLabelValue } from '@tcp/core/src/utils/utils';
import InputCheckbox from '@tcp/core/src/components/common/atoms/InputCheckbox';
import withStyles from '@tcp/core/src/components/common/hoc/withStyles';
import { formatPhoneNumber } from '@tcp/core/src/utils/formValidation/phoneNumber';
import ReduxFormIntlTelInput from '@tcp/core/src/components/common/atoms/CustomPhoneNumber/views/CustomPhoneNumberInput.jsx';
import styles from '../styles/Pickup.style';
import SMSFormFields from '../../../../../../common/molecules/SMSFormFields';
import EmailSignUpCheckBox from '../../../../Checkout/molecules/EmailSignUpCheckBox';

function PickupAddressForm(props) {
  const {
    className,
    formSection,
    addAltPersonSwitch,
    showIndicatorIcon,
    smsSignUpLabels,
    isUsSite,
    emailSignUpFlags,
    emailSignUpLabels,
    emailSignUpCaRichText,
    isChildrenPalace,
    isGymboree,
    isSnJ,
    isBossBopisOrder,
    initialValues,
    isLoginV2FlowEnabled,
    savedEmail,
    emailFailSafe,
    venmoStatus,
    isPlccIC,
    pageCategory,
    orderTrackingEnhancementEnabled,
    dispatchFormFieldChange,
    setPhoneCountryAction,
    isInternationalPhoneNumberEnabled,
  } = props;
  const globalGenericLabels = getLabelFromCopyOrFromTranslation(
    GLOBAL_GENERIC_LABELS,
    GlobalGenericLabels
  );

  const globalAddEditAddressLabels = getLabelFromCopyOrFromTranslation(
    GLOBAL_ADD_EDIT_ADDRESS_LABELS,
    GlobalAddEditAddressLabels
  );

  const checkoutPickupLabels = getLabelFromCopyOrFromTranslation('checkout.pickup', checkoutLabels);
  const isEmailSignedUp = initialValues?.emailSignUp?.emailSignUp;
  const renderEmailSignUp = () => {
    return (
      <Row fullBleed>
        <FormSection name="emailSignUp">
          <EmailSignUpCheckBox
            labels={emailSignUpLabels}
            fieldName="emailSignUp"
            bottomSeparator
            emailSignUpFlags={emailSignUpFlags}
            emailSignUpCaRichText={emailSignUpCaRichText}
            isSnJ={isSnJ}
            isUsSite={isUsSite}
            isGymboree={isGymboree}
            isChildrenPalace={isChildrenPalace}
            spc
            isCheckedTCP={isEmailSignedUp?.emailSignUpTCP}
            isCheckedGYM={isEmailSignedUp?.emailSignUpGYM}
            isLoginV2FlowEnabled={isLoginV2FlowEnabled}
          />
        </FormSection>
      </Row>
    );
  };
  const isSMSChecked = initialValues?.smsSignUp?.sendOrderUpdate;
  return (
    <div className={className}>
      <Row fullBleed>
        <Col
          ignoreGutter={{ small: true, medium: true, large: true }}
          colSize={{ small: 6, medium: 8, large: 12 }}
        >
          <Field
            placeholder={renderLabel(globalGenericLabels.lbl_firstName, 'lbl_firstName')}
            name="firstName"
            id={`${formSection}.firstName`}
            component={TextBox}
            dataLocator="first-name-field"
            className="elem-mb-MED elem-mt-XS"
            enableSuccessCheck={false}
            spc
            autoFocus
            showIndicatorIcon={showIndicatorIcon}
          />
        </Col>
      </Row>
      <Row fullBleed>
        <Col colSize={{ small: 6, medium: 8, large: 12 }}>
          <Field
            placeholder={renderLabel(globalGenericLabels.lbl_lastName, 'lbl_lastName')}
            name="lastName"
            id={`${formSection}.lastName`}
            component={TextBox}
            dataLocator="last-name-field"
            className="elem-mb-MED"
            enableSuccessCheck={false}
            spc
            showIndicatorIcon={showIndicatorIcon}
          />
        </Col>
      </Row>
      {isBossBopisOrder && isLoginV2FlowEnabled && (
        <>
          <Row fullBleed>
            <Col colSize={{ small: 6, medium: 8, large: 12 }} className="elem-mb-MED">
              {!isInternationalPhoneNumberEnabled ? (
                <Field
                  placeholder={renderLabel(globalGenericLabels.lbl_phone_no, 'lbl_phone_no')}
                  id={`${formSection}.phoneNumber`}
                  name="phoneNumber"
                  component={TextBox}
                  dataLocator="addnewaddress-phnumber"
                  type="tel"
                  enableSuccessCheck={false}
                  normalize={formatPhoneNumber}
                  autocomplete="tel"
                  spc
                  isRequired
                  showIndicatorIcon={showIndicatorIcon}
                />
              ) : (
                <Field
                  name="phoneNumber"
                  component={ReduxFormIntlTelInput}
                  className={`${className} elem-pb-XS `}
                  id={`${formSection}.phoneNumber`}
                  dataLocator="phone-number-field"
                  dispatchFormFieldChange={dispatchFormFieldChange}
                  defaultPhoneNumber={initialValues?.phoneNumber}
                  defaultCountryCode={initialValues?.phoneCountryCode}
                  labelValue={globalGenericLabels[lblPhoneNumber]}
                  isPlccIC={isPlccIC}
                  setPhoneCountryAction={setPhoneCountryAction}
                />
              )}
            </Col>
          </Row>
          {(!savedEmail || emailFailSafe || venmoStatus) && (
            <Row fullBleed>
              <Col colSize={{ small: 6, medium: 8, large: 12 }} className="elem-mb-MED">
                <Field
                  placeholder={renderLabel(
                    globalAddEditAddressLabels.lbl_addEditAddress_email,
                    'lbl_addEditAddress_email'
                  )}
                  name="emailAddress"
                  id={`${formSection}.emailAddress`}
                  component={TextBox}
                  dataLocator="email-address-field"
                  enableSuccessCheck={false}
                  autocomplete="email"
                  spc
                  isRequired
                  showIndicatorIcon={showIndicatorIcon}
                />
              </Col>
            </Row>
          )}
          {pageCategory !== 'bagPage' && !isPlccIC && isUsSite && !orderTrackingEnhancementEnabled && (
            <Row fullBleed>
              <FormSection name="smsSignUp">
                <SMSFormFields
                  labels={smsSignUpLabels}
                  colSize={{ small: 6, medium: 8, large: 12 }}
                  showDefaultCheckbox={false}
                  formName="PickupForm"
                  formSection="sendOrderUpdate"
                  variation="secondary"
                  isOrderUpdateChecked
                  smsOrderUpdatesRichText={smsSignUpLabels && smsSignUpLabels.smsSignupText}
                  spc
                  isSMSChecked={isSMSChecked}
                  isLoginV2FlowEnabled={isLoginV2FlowEnabled}
                />
              </FormSection>
            </Row>
          )}
          {!isUsSite && renderEmailSignUp()}
        </>
      )}
      <Row fullBleed>
        <div className="helper-text-parent">
          <span className="helper-text-child">
            {renderLabel(checkoutPickupLabels.lbl_pickup_desc_one, 'lbl_pickup_desc_one')}
          </span>
        </div>
      </Row>
      {isLoginV2FlowEnabled ? (
        <div className="checkbox-header elem-mb-LRG">
          <Field
            name="addAltPersonSwitch"
            id={`${formSection}.addAltPersonSwitch`}
            component={InputCheckbox}
            dataLocator="hide-show-checkbox"
            enableSuccessCheck={false}
            className="giftServicesField"
            spc
            isLoginV2FlowEnabled
            pickupCheckBox
          />
          <Row fullBleed className="checkbox-header title g ">
            <BodyCopy
              component="div"
              className="elem-pl-MED elem-mt-XXXS mobile-title"
              fontFamily="secondary"
              fontWeight="semibold"
              fontSize="fs14"
            >
              {renderLabel(
                checkoutPickupLabels.lbl_alternate_person_switch,
                'lbl_alternate_person_switch'
              )}
            </BodyCopy>
          </Row>
        </div>
      ) : (
        <Row fullBleed>
          <Col
            className="send-order-update elem-mb-LRG"
            colSize={{ small: 6, medium: 8, large: 12 }}
          >
            <Field
              name="addAltPersonSwitch"
              id={`${formSection}.addAltPersonSwitch`}
              component={InputCheckbox}
              dataLocator="hide-show-checkbox"
              enableSuccessCheck={false}
              defaultValue={addAltPersonSwitch}
              className="send-order-update"
            >
              <BodyCopy
                fontSize={['fs12', 'fs16', 'fs16']}
                fontFamily="secondary"
                fontWeight="regular"
                dataLocator="orderUpdate-chk"
                className="spc-order-update"
              >
                {renderLabel(
                  checkoutPickupLabels.lbl_alternate_person_switch,
                  'lbl_alternate_person_switch'
                )}
              </BodyCopy>
            </Field>
          </Col>
        </Row>
      )}

      {addAltPersonSwitch && (
        <>
          <Row fullBleed>
            <Col
              ignoreGutter={{ small: true, medium: true, large: true }}
              colSize={{ small: 6, medium: 8, large: 12 }}
            >
              <Field
                placeholder={getLabelValue(globalGenericLabels, 'lbl_firstName')}
                name="firstName_alt"
                id={`${formSection}.firstName_alt`}
                component={TextBox}
                dataLocator="first-name-field"
                className="elem-mb-MED elem-mt-XS"
                enableSuccessCheck={false}
                spc
                showIndicatorIcon={showIndicatorIcon}
              />
            </Col>
          </Row>

          <Row fullBleed>
            <Col colSize={{ small: 6, medium: 8, large: 12 }}>
              <Field
                placeholder={getLabelValue(globalGenericLabels, 'lbl_lastName')}
                name="lastName_alt"
                id={`${formSection}.lastName_alt`}
                component={TextBox}
                dataLocator="last-name-field"
                className="elem-mb-MED"
                enableSuccessCheck={false}
                spc
                showIndicatorIcon={showIndicatorIcon}
              />
            </Col>
          </Row>
          <Row fullBleed>
            <Col colSize={{ small: 6, medium: 8, large: 12 }}>
              <Field
                placeholder={renderLabel(
                  globalAddEditAddressLabels.lbl_addEditAddress_email,
                  'lbl_addEditAddress_email'
                )}
                name="emailAddress_alt"
                id={`${formSection}.emailAddress_alt`}
                component={TextBox}
                dataLocator="email-field"
                className="elem-mb-MED"
                enableSuccessCheck={false}
                spc
                showIndicatorIcon={showIndicatorIcon}
              />
            </Col>
          </Row>
          <Row fullBleed>
            <div className="helper-text-parent">
              <span className="helper-text-child">
                {' '}
                {renderLabel(checkoutPickupLabels.lbl_pickup_desc_two, 'lbl_pickup_desc_two')}
              </span>
            </div>
          </Row>
        </>
      )}
    </div>
  );
}

PickupAddressForm.propTypes = {
  formSection: PropTypes.string,
  addAltPersonSwitch: PropTypes.bool.isRequired,
  section: PropTypes.shape({}).isRequired,
  showIndicatorIcon: PropTypes.string,
  isLoginV2FlowEnabled: PropTypes.bool,
};

PickupAddressForm.defaultProps = {
  formSection: '',
  showIndicatorIcon: true,
  isLoginV2FlowEnabled: false,
};

export default withStyles(PickupAddressForm, styles);
